import React, { ReactNode } from 'react'
import { InfoDisplay } from '../../components/utility/Containers'
import { Box } from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  gDriveContentFilesForSelectedCourseAtom,
  gDriveFilesForSelectedCourseAtom,
  selectedCourseAtom,
} from './atoms'
import { googleUserAtom } from 'infrastructure/googleDrive'
import { usePairedFileForKey } from './hooks'
import { formatDistanceToNow } from 'date-fns'

export function Walkthrough() {
  return (
    <Box padding="20px">
      <InfoDisplay>
        <CurrentStatus />
      </InfoDisplay>
    </Box>
  )
}

export function CurrentStatus() {
  const selectedCourse = useAtomValue(selectedCourseAtom)
  const { credential } = useAtomValue(googleUserAtom)
  const files = useAtomValue(gDriveFilesForSelectedCourseAtom)
  const courseFiles = useAtomValue(gDriveContentFilesForSelectedCourseAtom)
  const pairedFile = usePairedFileForKey()

  const messages: ReactNode[] = [<b key={'b'}>OSE Ingestion Walkthrough</b>]

  if (!selectedCourse) {
    return 'First select a course to ingest using the course dropdown.'
  }

  messages.push(`Great, you selected ${selectedCourse} to ingest`)
  const compile = () => {
    return messages.map((m, index) => (
      <Box padding="5px" key={index}>
        {m}
      </Box>
    ))
  }

  if (!credential?.accessToken) {
    messages.push(
      'Now you need to authorize Google to retrieve the Google source directory.',
    )
    return compile()
  }

  const fileCount =
    files &&
    files.reduce<number>(
      (acc, { fileMap }) => acc + Object.keys(fileMap ?? {}).length,
      0,
    )

  if (!fileCount) {
    messages.push(
      'Now we need the Google Drive location where the files for this course are located. You can select the folder options in the folder dropdown. If you dont see your location you can select Input Location and put it in the input. Once youve selected a location press the Retrieve Files button to get the files.',
    )
    return compile()
  }

  if (!courseFiles) {
    messages.push(
      'Ok weve got Google Drive files, youll want to verify that we have everything expected. You can check each unit summary for the lesson count and for the aux files.',
    )
    messages.push(
      'We need to retrieve the content of the Google Drive files, to initiate that press the Retrieve Course Files button. This might take a little time.',
    )
    return compile()
  }

  if (!pairedFile) {
    messages.push(
      'Now you need to ingest before creating a tree. Press the Hasnt Been Parsed button to create the ingestion from which we will create the tree.',
    )
    return compile()
  }

  messages.push(
    `Youre ready to create a new tree for this course. The current ingestion is from ${formatDistanceToNow(new Date(pairedFile.last_modified))} ago, if you need to update this before creating a tree press the ${formatDistanceToNow(new Date(pairedFile.last_modified))} ago button, you'll see it update.`,
  )
  messages.push(
    'To create a new tree from this last ingestion press the Create Tree button.',
  )
  return compile()
}
